import { ALBERTA_LOCATION_IDS } from '@/constants/location'
import { ProvinceAbbreviation } from '@/generated/graphql-types'

/**
 * Checks if the given location is in the province of Alberta based on location
 * ID or address. If they are in a region or city in Alberta, this function
 * should return true
 *
 * @returns boolean
 */
export const isLocationInAlberta = ({
  id,
  streetAddress,
}: {
  id?: number
  streetAddress?: string | null
}): boolean => {
  const isIdInAB = id && ALBERTA_LOCATION_IDS.includes(id)
  const isAddressInAB = streetAddress?.split(',').pop()?.trim() === ProvinceAbbreviation.Ab

  return isIdInAB || isAddressInAB
}
